export default __webpack_public_path__ + "cd0881065ac1b20ffd0909e0dbe113e2.png";